import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function Slide04SamplingBroken() {
  const problems = ['Expensive staff & logistics', 'No data flow or insights', 'Only local activations', 'Coupon monopoly = extreme costs'];
  return <div className="flex flex-col h-full justify-center max-w-5xl mx-auto w-full" data-id="element-60">
      <motion.div className="text-center mb-16" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-61">
        <h2 className="text-5xl font-bold text-white mb-4" data-id="element-62">
          Sampling Today is{' '}
          <span className="text-red-400 line-through decoration-4 decoration-white" data-id="element-63">
            Broken
          </span>
        </h2>
        <p className="text-xl text-white/60" data-id="element-64">(10,000 samples ≈ 300,000 kr)</p>
      </motion.div>

      <div className="relative" data-id="element-65">
        {/* Broken rod visual */}
        <motion.div className="absolute left-1/2 top-0 bottom-0 w-1 bg-white/10 -translate-x-1/2" initial={{
        height: 0
      }} animate={{
        height: '100%'
      }} transition={{
        duration: 1
      }} data-id="element-66" />

        <div className="space-y-8 relative z-10" data-id="element-67">
          {problems.map((problem, i) => <motion.div key={i} initial={{
          x: i % 2 === 0 ? -100 : 100,
          opacity: 0
        }} animate={{
          x: 0,
          opacity: 1
        }} transition={{
          delay: i * 0.2,
          type: 'spring'
        }} className={`flex items-center gap-6 p-6 rounded-xl bg-red-500/10 border border-red-500/30 backdrop-blur-sm max-w-2xl mx-auto`} data-id="element-68">
              <XCircle className="w-8 h-8 text-red-400 flex-shrink-0" data-id="element-69" />
              <span className="text-2xl font-medium text-white" data-id="element-70">{problem}</span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}